import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App';
import './estilos.css';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('elemento #raiz não encontrado');

const arvore = (
  <StrictMode>
    <App />
  </StrictMode>
);

/*
  HIDRATA se o HTML já veio pronto; MONTA do zero se não veio.

  O build costura a página inteira dentro de `#raiz`
  (`scripts/prerenderizar.mjs`), então em produção o caminho é sempre a
  hidratação: o React ADOTA o DOM que já está na tela, em vez de descartá-lo e
  reconstruir — que é o que `createRoot` faria, apagando o conteúdo
  pré-renderizado e devolvendo justamente o pisca-pisca que ele existe para
  evitar.

  O ramo do `createRoot` não é defensivo à toa: no `vite dev` não há
  pré-render, o `#raiz` chega vazio, e hidratar contêiner vazio faria o React
  acusar divergência na árvore inteira.
*/
if (raiz.hasChildNodes()) {
  hydrateRoot(raiz, arvore);
} else {
  createRoot(raiz).render(arvore);
}
